document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('[data-color-root]');
  if (!root) return;

  const btnOpen  = root.querySelector('[data-color-open]');
  const drawer   = root.querySelector('[data-color-drawer]');
  const closers  = root.querySelectorAll('[data-color-close]');

  const open = () => {
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.setAttribute('data-open', 'true'));
    // bloquear scroll de fondo
    document.documentElement.style.overflow = 'hidden';
  };
  const close = () => {
    drawer.removeAttribute('data-open');
    // esperar transición
    setTimeout(() => { drawer.hidden = true; }, 330);
    document.documentElement.style.overflow = '';
  };

  btnOpen?.addEventListener('click', open);
  closers.forEach(el => el.addEventListener('click', close));

  // cerrar con ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer?.getAttribute('data-open') === 'true') close();
  });

  // cerrar al click fuera del panel
  drawer?.addEventListener('click', (e) => {
    const panel = drawer.querySelector('.color-drawer__panel');
    if (!panel.contains(e.target)) close();
  });
});
